import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { CSSEvent } from "../../types/model";
import { Page } from "../../types/Seo";
import {
  getSelectedStore,
  useAppContext,
} from "../../contextProviders/AppContext";
import getEventDetailsSeo from "./getEventDetailsSeo";
import { EVENT_DETAILS, EVENT_LIST, EVENT_STORE_LIST } from "./enums";
import getEventListSeo from "./getEventListSeo";
import { config as CSSConfig } from "../../config";

type PropsType = {
  event?: CSSEvent;
  page: Page;
  canonicalPath?: string;
};

const Seo = ({ event, page, canonicalPath }: PropsType) => {
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const selectedStore = useSelector(getSelectedStore);
  let config = null;

  if (page === EVENT_DETAILS && event) {
    config = getEventDetailsSeo(selectedStore, event, t);
  } else if ([EVENT_LIST, EVENT_STORE_LIST].indexOf(page) > -1) {
    config = getEventListSeo(selectedStore, page, t);
  }

  return (
    <Helmet
      defaultTitle={t("storeEventCustomer.title")}
      title={config?.title}
      meta={config?.meta}
    >
      {config?.jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(config?.jsonLd, null, 2)}
        </script>
      )}
      {config?.canonicalPath && (<link
        rel="canonical"
        href={`${CSSConfig.canonicalHost}/${config?.canonicalPath}`}
      />)};
    </Helmet>
  );
};

export default Seo;
